import { render, staticRenderFns } from "./PracticeList.vue?vue&type=template&id=0f9387b8&"
import script from "./PracticeList.vue?vue&type=script&lang=ts&"
export * from "./PracticeList.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports